import { render, staticRenderFns } from "./bodyFunction.vue?vue&type=template&id=29f3875c&scoped=true"
import script from "./bodyFunction.vue?vue&type=script&lang=js"
export * from "./bodyFunction.vue?vue&type=script&lang=js"
import style0 from "./bodyFunction.vue?vue&type=style&index=0&id=29f3875c&prod&lang=scss&scoped=true"
import style1 from "./bodyFunction.vue?vue&type=style&index=1&id=29f3875c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f3875c",
  null
  
)

export default component.exports